"use client";
import React from "react";
import Image from "next/image";
import { SearchFormHandle } from "@packages/lib/types/interfaces";
import Form from "next/form";
import { useState, useEffect, useRef } from "react";
import { useRouter, usePathname, useSearchParams } from "next/navigation";
import {
  GADataLayerFn,
  GA4DataLayerFn,
  currentAuthenticatedUser,
  GA4DataLayer,
} from "@packages/lib/utlils/helper-function";
import emitter from "@packages/lib/eventEmitter/eventEmitter";
import { fetchAuthSession } from "aws-amplify/auth";
import { getCookie } from "@packages/lib/utlils/helper-function";
import {
  ClickstreamConstants,
  GAConstants,
} from "@packages/shared-components/services/constants";
import {
  ClickstreamInterface,
  logClickstreamEvent,
} from "@packages/lib/utlils/clickstream";
import { KeyNames } from "@packages/lib/utlils/filters/filterJson";
import { DataLayerGA4AttrType } from "@packages/lib/types/datalayerGA";
import { parseUCASCookie } from "@packages/lib/utlils/getUcasvalue";
import { deleteDocumentCookie } from "@packages/lib/utlils/cookie-utils";
import makeApiCall from "@packages/lib/server-actions/rest-api";
import getApiUrl from "@packages/lib/server-actions/api-urls";
import { isWhatuni } from "@packages/lib/utlils/commonFunction";
interface CourseTabProps {
  customGA?: DataLayerGA4AttrType;
  searchFormHandle: any;
  setsearchFormHandle: any;
  data: any;
  placeholder: any;
  showlocation: any;
  gaEventName?: string;
  isScholarshipSearch?: boolean;
  commonGAAttrs?: any;
}

const CourseTab: React.FC<CourseTabProps> = ({
  customGA,
  searchFormHandle,
  setsearchFormHandle,
  data,
  placeholder,
  showlocation,
  gaEventName,
  isScholarshipSearch = false,
  commonGAAttrs,
}) => {
  let ucasval: any = 0;
  let min: any = 0;
  const pathName = usePathname();
  const searchParams = useSearchParams();
  const containerRef = useRef<HTMLDivElement | null>(null);
  const [isAuthenticated, setIsAuthenticated] = useState<any>(false);
  const [subjectlist, setSubjectlist] = useState(data?.courseDetails);
  const [locationlist, setLocationlist] = useState(data?.locationList);
  const [studymodelist, setStudymodelist] = useState(data?.studyLevelList);
  const [scholarshiplist, setScholarshiplist] = useState<any[]>([]);
  //const [buttonName, setButtonName] = useState("Search");
  const [dropdownIndex, setdropdownIndex] = useState<number>(0);
  const [dropdownIndexQual, setdropdownIndexQual] = useState<number>(0);
  const [filteredsubject, setFilteredsubject] = useState<
    { [key: string]: any; description: string }[] | any
  >(undefined);
  const [isLoadingSubject, setIsLoadingSubject] = useState(false);
  const [isLoadingkeyword, setIsLoadingkeyword] = useState(false);
  const [subjecterror, setSubjecterror] = useState(false);
  const [dropdown, setDropdown] = useState<boolean>(false);

  const router = useRouter();
  useEffect(() => {
    setSubjectlist(data?.courseDetails);
    setLocationlist(data?.locationList);
    setStudymodelist(data?.studyLevelList);
  }, [data]);

  // function getClearingAttr() {
  //   return customGA?.clearing || localStorage?.getItem("clearing") || "in-year";
  // }

  function navigateTo(newUrl: string) {
    //router.prefetch(newUrl);
    sessionStorage.removeItem("filter_param");
    deleteDocumentCookie({ name: "filter_param" });
    emitter.emit("refreshFilters");
    window.history.pushState(null, "", newUrl);
    //setTimeout(() => router.push(newUrl), 0);
    // router.push(newUrl);
    window.location.href = newUrl;
    setTimeout(() => emitter.emit("rightMenuActionclose", "closesearch"), 100);
  }
  // ==============================use effect to check the use authentication======================================================================
  useEffect(() => {
    const fetchUser = async () => {
      try {
        const session = await fetchAuthSession({ forceRefresh: true });

        if (session.tokens) {
          const hasAccessToken = session.tokens.accessToken !== undefined;
          const hasIdToken = session.tokens.idToken !== undefined;
          if (hasAccessToken && hasIdToken) {
            setIsAuthenticated(true);
          } else {
            setIsAuthenticated(false);
          }
        }
      } catch (error) {
        console.error("Error fetching user:", error);
      }
    };
    fetchUser();
  }, []);

  // ==========================use effect for the handle click outside========================================================================
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        containerRef.current &&
        !containerRef.current.contains(event.target as Node)
      ) {
        courseActions("UG");
        courseActions("Subject");
        setDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // ============================== use effect for filter subject list========================================================================
  useEffect(() => {
    const { description } = searchFormHandle.subject || {};
    const { qualCode } = searchFormHandle.courseType || {};
    if (!description?.trim() || description?.trim().length < 3) {
      setFilteredsubject([]);
      return;
    }

    const filteredSubjects = !isScholarshipSearch
      ? subjectlist?.filter(
          (subjects: any) =>
            subjects?.description
              ?.toLowerCase()
              .includes(description?.trim()?.toLowerCase()) &&
            subjects?.qualCode === qualCode,
        )
      : scholarshiplist?.filter((subjects: any) =>
          subjects?.description
            ?.toLowerCase()
            .includes(description?.trim()?.toLowerCase()),
        );
    const prioritySearch = (
      list: { description: string; [key: string]: any }[],
      searchText: string,
    ): { description: string; [key: string]: any }[] => {
      if (!searchText) return list;
      const searchLower = searchText?.toLowerCase();
      return list
        ?.map((item) => ({
          ...item,
          position: item?.description?.toLowerCase().indexOf(searchLower),
          startsWithSearch: item?.description
            ?.toLowerCase()
            ?.startsWith(searchLower),
          exactMatch: item?.description?.toLowerCase() === searchLower,
        }))

        .filter((item) => item.position !== -1)
        .sort((a, b) => {
          if (a.exactMatch !== b.exactMatch) return a.exactMatch ? -1 : 1;
          if (a.startsWithSearch !== b.startsWithSearch)
            return a.startsWithSearch ? -1 : 1;
          if (a.position !== b.position) return a.position - b.position;
          return a?.description?.localeCompare(b?.description);
        })
        ?.map((item: any) => ({
          description: item?.description,
          url: item.url,
          category_code: item.category_code,
          browse_cat_id: item.browse_cat_id,
          parent_subject: item.parentSubject,
          qual_Code: item?.qualCode,
          collegeId: item?.collegeId,
          collegeName: item?.collegeName,
          subjectName: item?.subjectName,
          scholarshipCount: item?.scholarshipCount,
        }));
    };
    setFilteredsubject(prioritySearch(filteredSubjects, description?.trim()));
  }, [
    searchFormHandle?.subject?.description,
    searchFormHandle?.courseType?.qualCode,
  ]);
  useEffect(() => {
    const fetchScholarshipSuggestions = async () => {
      try {
        const affiliateId = `${process.env.AFFILATE_ID}`;

        const queryParams = new URLSearchParams({
          actionType: "BOTH",
          affiliateId: affiliateId,
        });

        const data = await makeApiCall({
          url: `${process.env.NEXT_PUBLIC_DOMSERVICE_API_DOMAIN}${getApiUrl?.universityAndSubjectAjax}?${queryParams.toString()}`,
          method: "GET",
          headers: {
            "x-api-key": `${process.env.NEXT_PUBLIC_DOMSERVICE_X_API_KEY}`,
          },
        });

        // Transform scholarship data to match existing structure
        const scholarshipSuggestions = [
          ...(data.subjectDetails || []).map((item: any) => ({
            description: item.subjectDesc,
            url: isWhatuni()
              ? `/money/scholarships/search/undergraduate/${item.subjectTextKey}`
              : `/funding/scholarships/search/${item.subjectTextKey}`,
            subjectTextKey: item.subjectTextKey,
            subjectName: item.subjectDesc,
            scholarshipCount: item.scholarshipCount,
            isScholarshipSubject: true,
          })),
          ...(data.universityDetails || []).map((item: any) => ({
            description: item.collegeNameDisplay,
            collegeId: item.collegeId,
            collegeName: item.collegeNameDisplay,
            url: isWhatuni()
              ? `/money/scholarships/csearch/undergraduate/${item.collegeTextKey}`
              : `/funding/scholarships/csearch/${item.collegeTextKey}`,
            collegeTextKey: item.collegeTextKey,
            scholarshipCount: item.scholarshipCount,
            isScholarshipUniversity: true,
          })),
        ];
        setScholarshiplist(scholarshipSuggestions);

        // setFilteredsubject(scholarshipSuggestions);
      } catch (error) {
        console.error("Error fetching scholarship suggestions:", error);
        setFilteredsubject([]);
      }
    };
    if (isScholarshipSearch) {
      fetchScholarshipSuggestions();
    }
  }, []);
  // ====================================================use effect for the clear subject on qual change============================================================================================
  useEffect(() => {
    setsearchFormHandle((prevData: any) => ({
      ...prevData,
      subject: {
        ...prevData.subject,
        url: null,
        parent_subject: null,
        category_code: null,
        browse_cat_id: "KW",
        description: "",
      },
    }));
  }, [searchFormHandle?.courseType?.qualCode]);
  const resetAllTabs = (currentTab: string) => ({
    isCourseType: currentTab === "UG" ? !searchFormHandle?.isCourseType : false,
    isSubjectClicked:
      currentTab === "Subject" ? !searchFormHandle?.isSubjectClicked : false,
    isLocationClicked:
      currentTab === "Location" ? !searchFormHandle?.isLocationClicked : false,
  });

  const courseActions = (tabName: string) => {
    setsearchFormHandle((prevData: SearchFormHandle) => ({
      ...prevData,
      ...resetAllTabs(tabName),
    }));
  };
  // ============================serch handler===============================================================================================================
  const searchHandler = () => {
    setIsLoadingSubject(true);
  };
  var csData: ClickstreamInterface = {} as ClickstreamInterface;
  useEffect(() => {
    if (isLoadingSubject) {
      const handlesearch = async () => {
        if (isAuthenticated) {
          const cookiesval = parseUCASCookie();
          const minval: any = getCookie("min");
          min = parseInt(minval, 10);
          ucasval = cookiesval;
        } else {
          const minval: any = getCookie("min");
          min = parseInt(minval, 10);
          const cookiesval1: any = decodeURIComponent(
            getCookie("UCAS") || "{}",
          );
          const point: any = JSON.parse(cookiesval1);
          ucasval = point?.ucasPoint;
        }
        if (
          searchFormHandle?.location?.regionUrl &&
          !searchFormHandle.subject.url &&
          !searchFormHandle?.subject?.description?.trim()
        ) {
          setSubjecterror(true);
          setIsLoadingSubject(false);
        }
        if (!searchFormHandle?.subject?.description?.trim()) {
          setSubjecterror(true);
          setIsLoadingSubject(false);
        }
        if (isScholarshipSearch && !searchFormHandle?.subject?.url) {
          setSubjecterror(true);
          setIsLoadingSubject(false);
          return;
        }
        if (
          searchFormHandle?.location?.regionUrl &&
          searchFormHandle?.subject?.url
        ) {
          GA4DataLayer({
            ...commonGAAttrs,
            event: GAConstants.track_event,
            event_name: "search_event",
            study_level: searchFormHandle?.courseType?.qualDesc,
            subject_area: searchFormHandle?.subject?.parent_subject
              ? searchFormHandle?.subject?.parent_subject
              : searchFormHandle?.subject?.description,
            subject_discipline: searchFormHandle?.subject?.parent_subject
              ? searchFormHandle?.subject?.description
              : "NA",
            search_type: "drop_down",
          });
          GA4DataLayerFn({
            ...commonGAAttrs,
            event: "ga_events",
             eventName: customGA?.eventName ?? gaEventName ?? "homepage_search",
             data_label: "subject_search",
            study_level: searchFormHandle?.courseType?.qualDesc,
            cpe_parent_subject: searchFormHandle?.subject?.parent_subject
              ? searchFormHandle?.subject?.parent_subject
              : searchFormHandle?.subject?.description,
            cpe_child_subject: searchFormHandle?.subject?.parent_subject
              ? searchFormHandle?.subject?.description
              : "NA",
          });
          clickStreamFindACourse(gaEventName, "", "");
          const newUrl = `${process.env.NEXT_PUBLIC_ENVIRONMENT === "prd" ? "https://www.whatuni.com" : ""}${searchFormHandle.subject.url}&location=${searchFormHandle?.location?.regionUrl}${ucasval ? `&score=${min ? min : "0"},${ucasval}` : ""}`;

          navigateTo(newUrl);
        } else if (searchFormHandle.subject?.url) {
          GA4DataLayer({
            ...commonGAAttrs,
            event: GAConstants.track_event,
            event_name: "search_event",
            study_level: searchFormHandle?.courseType?.qualDesc,
            subject_area: searchFormHandle?.subject?.parent_subject
              ? searchFormHandle?.subject?.parent_subject
              : searchFormHandle?.subject?.description,
            subject_discipline: searchFormHandle?.subject?.parent_subject
              ? searchFormHandle?.subject?.description
              : "NA",
            search_type: "drop_down",
          });
          GA4DataLayerFn({
            ...commonGAAttrs,
            event: "ga_events",
             eventName: customGA?.eventName ?? gaEventName ?? "homepage_search",
             data_label: "subject_search",
            study_level: searchFormHandle?.courseType?.qualDesc,
            cpe_parent_subject: searchFormHandle?.subject?.parent_subject
              ? searchFormHandle?.subject?.parent_subject
              : searchFormHandle?.subject?.description,
            cpe_child_subject: searchFormHandle?.subject?.parent_subject
              ? searchFormHandle?.subject?.description
              : "NA",
          });
          clickStreamFindACourse(gaEventName, "", "");
          const newUrl = `${process.env.NEXT_PUBLIC_ENVIRONMENT === "prd" ? "https://www.whatuni.com" : ""}${searchFormHandle.subject.url}${ucasval ? `&score=${min ? min : "0"},${ucasval}` : ""}`;
          navigateTo(newUrl);
        } else if (
          searchFormHandle?.subject?.description?.trim() &&
          !isScholarshipSearch
        ) {
          keywordSearch(true);
        }
      };
      handlesearch();
    }
  }, [isLoadingSubject]);

  const keywordSearch = async (canmatch: any) => {
    setIsLoadingkeyword(true);
    const sanitizedDescription = searchFormHandle?.subject?.description
      .trim()
      .replace(/[^a-zA-Z0-9\s]+/g, "-")
      .replace(/\s+/g, "-")
      .replace(/-+/g, "-")
      .replace(/^-|-$/g, "")

      ?.toLowerCase();
    const searchUrlMap: Record<string, string> = {
      M: "/degree-courses/search",
      N: "/hnd-hnc-courses/search",
      T: "/access-foundation-courses/search",
      A: "/foundation-degree-courses/search",
      L: "/postgraduate-courses/search",
    };
    const matchedSubject = filteredsubject?.find(
      (item: any) =>
        item?.description?.toLowerCase() ===
        searchFormHandle?.subject?.description?.trim()?.toLowerCase(),
    );

    if (searchFormHandle.location?.regionUrl && matchedSubject && canmatch) {
      const sanitizedRegionName = searchFormHandle?.location?.regionUrl
        .trim() // Remove spaces from the front and back
        .replace(/[^a-zA-Z0-9\s]+/g, "-") // Replace one or more special characters with a hyphen
        .replace(/\s+/g, "-") // Replace spaces with hyphens
        .replace(/-+/g, "-") // Replace multiple consecutive hyphens with a single hyphen
        .replace(/^-|-$/g, "") // Remove hyphens from the start and end
        ?.toLowerCase(); // Convert the entire string to lowercase
      //   GA4DataLayer({
      //       event: GAConstants.track_event,
      //       event_name: "search_event",
      //       study_level: searchFormHandle?.courseType?.qualDesc,
      //       search_type : "keyword",
      //       subject_area: matchedSubject?.parent_subject
      //     ? matchedSubject?.parent_subject
      //     : matchedSubject?.description,
      //       subject_discipline:  matchedSubject?.parent_subject ? matchedSubject?.description : "NA",
      //     })
      // clickStreamFindACourse(gaEventName, matchedSubject, "");

      const newUrl = `${process.env.NEXT_PUBLIC_ENVIRONMENT === "prd" ? "https://www.whatuni.com" : ""}${matchedSubject.url}&location=${sanitizedRegionName}${ucasval ? `&score=${min ? min : "0"},${ucasval}` : ""}`;
      navigateTo(newUrl);
    }
    if (matchedSubject && canmatch) {
      GA4DataLayer({
        ...commonGAAttrs,
        event: GAConstants.track_event,
        event_name: "search_event",
        search_type: "keyword",
        study_level: searchFormHandle?.courseType?.qualDesc,
        subject_area: matchedSubject?.parent_subject
          ? matchedSubject?.parent_subject
          : matchedSubject?.description,
        subject_discipline: matchedSubject?.parent_subject
          ? matchedSubject?.description
          : "NA",
      });
      GA4DataLayerFn({
        ...commonGAAttrs,
        event: "ga_events",
        eventName: customGA?.eventName ?? gaEventName ?? "homepage_search",
        data_label: "keyword_search",
        study_level: searchFormHandle?.courseType?.qualDesc,
        cpe_parent_subject: matchedSubject?.parent_subject
          ? matchedSubject?.parent_subject
          : matchedSubject?.description,
        cpe_child_subject: matchedSubject?.parent_subject
          ? matchedSubject?.description
          : "NA",
      });
      clickStreamFindACourse(gaEventName, matchedSubject, "");

      const newUrl = `${process.env.NEXT_PUBLIC_ENVIRONMENT === "prd" ? "https://www.whatuni.com" : ""}${matchedSubject.url}${ucasval ? `&score=${min ? min : "0"},${ucasval}` : ""}`;
      navigateTo(newUrl);
    }
    const baseUrl = searchUrlMap[searchFormHandle?.courseType?.qualCode];
    if (baseUrl) {
      GA4DataLayer({
        ...commonGAAttrs,
        event: GAConstants.track_event,
        event_name: "search_event",
        search_type: "keyword",
        study_level: searchFormHandle?.courseType?.qualDesc,
        subject_area: matchedSubject?.parent_subject
          ? matchedSubject?.parent_subject
          : matchedSubject?.description,
        subject_discipline: matchedSubject?.parent_subject
          ? matchedSubject?.description
          : "NA",
      });
      GA4DataLayerFn({
        ...commonGAAttrs,
        event: "ga_events",
        eventName: customGA?.eventName ?? gaEventName ?? "homepage_search",
        data_label: "keyword_search",
        study_level: searchFormHandle?.courseType?.qualDesc,
        cpe_parent_subject: matchedSubject?.parent_subject
          ? matchedSubject?.parent_subject
          : matchedSubject?.description,
        cpe_child_subject: matchedSubject?.parent_subject
          ? matchedSubject?.description
          : "NA",
      });
      clickStreamFindACourse(gaEventName, matchedSubject, sanitizedDescription);
      return navigateTo(
        `${process.env.NEXT_PUBLIC_ENVIRONMENT === "prd" ? "https://www.whatuni.com" : ""}${baseUrl}?q=${sanitizedDescription}`,
      );
    }
  };
  useEffect(() => {
    const bodyContainer: any = document.getElementById("bodyContainer");
    const footer: any = document.getElementById("footerComponent");
    if (!bodyContainer) {
      return;
    }
    if (
      (isLoadingSubject || isLoadingkeyword) &&
      !pathName?.includes("courses/search")
    ) {
      emitter.emit("searchpageloading", true);
      bodyContainer?.classList?.add("hidden");
      footer?.classList?.add("hidden");
    } else {
      emitter.emit("searchpageloading", false);
      bodyContainer?.classList?.remove("hidden");
      footer?.classList?.remove("hidden");
    }
  }, [isLoadingSubject, isLoadingkeyword]);

  const clickStreamFindACourse = (
    gaEventName: any,
    matchedSubject: any,
    sanitizedDescription: string,
  ): void => {
    if (gaEventName === "cdpage_footer_search") {
      csData.actionType = ClickstreamConstants.clickAction;
      csData.eventType = ClickstreamConstants.searchbarEvent;
      csData.browseNodeSubjects = searchFormHandle.subject.url;
      csData.studyLevel = searchFormHandle?.courseType?.qualDesc;
      csData.subject = searchFormHandle?.subject?.description
        ? searchFormHandle?.subject?.description
        : searchFormHandle?.subject?.parent_subject;
      csData.searchKeyword = (!matchedSubject && sanitizedDescription) || "";
      csData.pageName = "Course Details";
      logClickstreamEvent(csData);
    }
  };
  return (
    <>
      <div className="flex flex-col gap-[16px]">
        <div
          ref={containerRef}
          className="bg-white rounded-[24px] p-[16px] border border-grey-200 hover:border-primary-500 shadow-custom-1 md:rounded-[32px] md:pl-[24px] md:p-[10px]"
        >
          <Form
            action={searchHandler}
            className="flex flex-col small md:flex-row md:items-center"
          >
            {!isScholarshipSearch && (
              <div className="relative shrink-0">
                <button
                  onClick={() => {
                    courseActions("UG");
                    setDropdown(false);
                  }}
                  onChange={(event: any) => {
                    setsearchFormHandle((prevData: SearchFormHandle) => ({
                      ...prevData,
                      courseType: { ...prevData, qualDesc: event.target.value },
                    }));
                  }}
                  data-text-id="course_type_dropdown_button"
                  className="w-full flex items-center justify-between gap-[4px] pr-0 pb-[24px] text-black md:min-w-[176px] md:w-fit md:pr-[16px] md:pb-0"
                  type="button"
                  // ===========================key handle for the qualification===================================================

                  onKeyDown={(e) => {
                    if (!searchFormHandle?.isCourseType) return;
                    const allOptions: any = studymodelist || [];
                    const currentIndex = dropdownIndexQual;
                    let newIndex = currentIndex;
                    switch (e.key) {
                      case "ArrowDown":
                        e.preventDefault();
                        newIndex =
                          currentIndex < allOptions.length - 1
                            ? currentIndex + 1
                            : 0;
                        setdropdownIndexQual(newIndex);
                        const nextElement = document.querySelector(
                          `[data-index-1="${newIndex + 1}"]`,
                        );
                        nextElement?.scrollIntoView({
                          block: "nearest",
                          behavior: "smooth",
                        });
                        document
                          .querySelectorAll("[data-index-1]")
                          .forEach((el) => {
                            el.classList.remove("bg-blue-50", "underline");
                          });
                        nextElement?.classList.add("bg-blue-50", "underline");
                        break;

                      case "ArrowUp":
                        e.preventDefault();
                        newIndex =
                          currentIndex > 0
                            ? currentIndex - 1
                            : allOptions.length - 1;
                        setdropdownIndexQual(newIndex);
                        const prevElement = document.querySelector(
                          `[data-index-1="${newIndex}"]`,
                        );
                        prevElement?.scrollIntoView({
                          block: "nearest",
                          behavior: "smooth",
                        });
                        document
                          .querySelectorAll("[data-index-1]")
                          .forEach((el) => {
                            el.classList.remove("bg-blue-50", "underline");
                          });
                        prevElement?.classList.add("bg-blue-50", "underline");
                        break;

                      case "Enter":
                        e.preventDefault();
                        const selectedElement: HTMLElement | undefined =
                          Array.from(
                            document.querySelectorAll<HTMLElement>(
                              ".block.px-\\[16px\\].py-\\[12px\\].hover\\:bg-blue-50.hover\\:underline.cursor-pointer",
                            ),
                          ).find(
                            (el) =>
                              el.classList.contains("bg-blue-50") ||
                              el.classList.contains("underline"),
                          );
                        if (selectedElement) {
                          const selectedIndex: any =
                            selectedElement?.getAttribute("data-index-1");
                          setsearchFormHandle((prevData: SearchFormHandle) => ({
                            ...prevData,
                            courseType: studymodelist[selectedIndex - 1],
                          }));
                          courseActions("UG");
                        }
                        break;
                    }
                  }}
                >
                  {searchFormHandle?.courseType?.qualDesc}
                  <Image
                    src="/static/assets/icons/arrow_down_black.svg"
                    width="20"
                    height="20"
                    alt="Search icon"
                  />
                </button>
                {searchFormHandle?.isCourseType && (
                  <div className="bg-white z-[1] shadow-custom-3 rounded-[4px] absolute left-[-16px] top-[45px] w-[calc(100%+32px)] md:w-[calc(100%+16px)]">
                    <ul>
                      {studymodelist?.map((item: any, index: any) => (
                        <li
                          onClick={() => {
                            setsearchFormHandle(
                              (prevData: SearchFormHandle) => ({
                                ...prevData,
                                courseType: item,
                              }),
                            );
                            courseActions("UG");
                          }}
                          className="block small px-[16px] py-[12px] hover:bg-blue-50 hover:underline cursor-pointer"
                          data-index-1={index + 1}
                          key={index}
                        >
                          {item.qualDesc}
                        </li>
                      ))}
                    </ul>
                  </div>
                )}
              </div>
            )}
            <div
              className={`w-full relative grow ${!isScholarshipSearch ? "border-y-[1px] border-grey-200 md:border-l md:border-y-0" : ""}`}
            >
              <input
                autoComplete="off"
                value={searchFormHandle?.subject?.description || ""}
                type="text"
                data-text-id="subject_search_input"
                className={`w-full focus:outline-none text-black placeholder:text-gray-500 ${isScholarshipSearch ? "" : "px-[0] py-[24px] md:px-[16px] md:py-[10px]"}`}
                aria-label="submenu"
                placeholder={
                  isScholarshipSearch
                    ? "Search subjects or universities"
                    : placeholder || "Enter Subject"
                }
                onChange={(event) => {
                  const trimmedValue = event.target.value.replace(
                    /\s{2,}/g,
                    " ",
                  );
                  setsearchFormHandle((prevData: any) => ({
                    ...prevData,
                    subject: {
                      ...prevData.subject,
                      url: null,
                      parent_subject: null,
                      category_code: null,
                      browse_cat_id: "KW",
                      description: trimmedValue.trimStart(),
                    },
                  }));
                  setDropdown(true);
                  setSubjecterror(false);
                }}
                onClick={() => {
                  courseActions("Subject");
                  setDropdown((prev) => !prev);
                  setdropdownIndex(0);
                }}
                onKeyDown={(e) => {
                  if (!dropdown) return;
                  const allOptions: any = filteredsubject || [];
                  const currentIndex = dropdownIndex;
                  let newIndex = currentIndex;
                  switch (e.key) {
                    case "ArrowDown":
                      e.preventDefault();
                      newIndex =
                        currentIndex < allOptions.length - 1
                          ? currentIndex + 1
                          : 0;
                      setdropdownIndex(newIndex);
                      const nextElement = document.querySelector(
                        `[data-index="${newIndex}"]`,
                      );
                      nextElement?.scrollIntoView({
                        block: "nearest",
                        behavior: "smooth",
                      });

                      document
                        .querySelectorAll("[data-index]")
                        .forEach((el) => {
                          el.classList.remove("bg-blue-50", "underline");
                        });
                      nextElement?.classList.add("bg-blue-50", "underline");
                      break;

                    case "ArrowUp":
                      e.preventDefault();
                      newIndex =
                        currentIndex > 0
                          ? currentIndex - 1
                          : allOptions.length - 1;
                      setdropdownIndex(newIndex);

                      const prevElement = document.querySelector(
                        `[data-index="${newIndex}"]`,
                      );
                      prevElement?.scrollIntoView({
                        block: "nearest",
                        behavior: "smooth",
                      });

                      document
                        .querySelectorAll("[data-index]")
                        .forEach((el) => {
                          el.classList.remove("bg-blue-50", "underline");
                        });
                      prevElement?.classList.add("bg-blue-50", "underline");
                      break;

                    case "Enter":
                      e.preventDefault();
                      const selectedElement: HTMLElement | undefined =
                        Array.from(
                          document.querySelectorAll<HTMLElement>(
                            ".block.px-\\[16px\\].py-\\[12px\\].hover\\:bg-blue-50.hover\\:underline.cursor-pointer",
                          ),
                        ).find(
                          (el) =>
                            el.classList.contains("bg-blue-50") ||
                            el.classList.contains("underline"),
                        );
                      if (selectedElement) {
                        const selectedIndex: any =
                          selectedElement?.getAttribute("data-index");

                        setsearchFormHandle((prevData: SearchFormHandle) => ({
                          ...prevData,
                          subject: filteredsubject[selectedIndex - 1],
                          isSubjectClicked: !searchFormHandle?.isSubjectClicked,
                        }));
                        setDropdown(false);
                      } else {
                        searchHandler();
                      }
                      break;
                  }
                }}
              />
              {dropdown && (
                <div className="bg-white z-[1] shadow-custom-3 rounded-[4px] absolute left-0 top-[43px] w-full max-h-[310px] overflow-y-auto custom-scrollbar-2">
                  {/* Hardcode the item at index 0 */}
                  {searchFormHandle?.subject?.description?.trim()?.length > 2 &&
                    !isScholarshipSearch && (
                      <div
                        onClick={() => {
                          setsearchFormHandle((prevData: SearchFormHandle) => ({
                            ...prevData,
                            subject: subjectlist[0],
                            isSubjectClicked:
                              !searchFormHandle?.isSubjectClicked,
                          }));
                          setDropdown(false);
                          keywordSearch(false);
                        }}
                        className="px-[16px] py-[12px] cursor-pointer"
                      >
                        <p className="x-small font-semibold text-black tracking-[1px] leading-[18px] uppercase">
                          Keyword search for
                        </p>
                        <p className="small text-primary-400">
                          {`'${searchFormHandle?.subject?.description}'`}
                        </p>
                      </div>
                    )}
                  <ul>
                    {/* Map through the rest of the items starting from index 1 */}
                    {filteredsubject?.map((item: any, index: any) => (
                      <li
                        onClick={() => {
                          if (isScholarshipSearch) {
                            const isSubjectSearch =
                              item?.url?.includes("/search/");
                            // GA4 tracking for scholarship search
                            GA4DataLayer({
                              event: GAConstants.track_event,
                              event_name: "search_event",
                              search_type: "drop_down",
                              subject_area: isSubjectSearch
                                ? item?.description
                                : "NA",
                              subject_discipline: item?.collegeName || "NA",
                              institution_id: !isSubjectSearch
                                ? String(item?.collegeId)
                                : "NA",
                              study_level: "undergraduate",
                            });

                            if (item.isScholarshipSubject && item.url) {
                              window.location.href = `${item.url}`;
                            } else if (!item.isScholarshipSubject && item.url) {
                              window.location.href = `${item.url}`;
                            }
                          } else {
                            setsearchFormHandle(
                              (prevData: SearchFormHandle) => ({
                                ...prevData,
                                subject: item,
                                isSubjectClicked:
                                  !searchFormHandle?.isSubjectClicked,
                              }),
                            );
                            setDropdown(false);
                          }
                        }}
                        data-index={index + 1}
                        key={index + 1}
                        className={`block small px-[16px] py-[12px] hover:bg-blue-50 hover:underline cursor-pointer`}
                      >
                        <div className="flex ga justify-between items-center">
                          <span>
                            {item?.description}
                            {isScholarshipSearch && (
                              <span className="text-small text-grey500 pl-[8px]">
                                {item?.scholarshipCount} scholarships
                              </span>
                            )}
                          </span>

                          {/* {isScholarshipSearch && (
                            <span className="text-xs text-gray-500">
                              {item.isScholarshipSubject ? 'Subject' : 'University'}
                            </span>
                          )} */}
                        </div>
                      </li>
                    ))}
                  </ul>
                </div>
              )}
            </div>
            {showlocation && !isScholarshipSearch && (
              <div
                className="w-full relative grow md:border-l border-grey-200"
                onClick={() => {
                  courseActions("Location");
                  setDropdown(false);
                }}
              >
                <input
                  autoComplete="off"
                  type="text"
                  data-text-id="location_search_input"
                  className="w-full focus:outline-none text-black placeholder:text-gray-500 px-[0] py-[24px] md:px-[16px] md:py-[10px]"
                  aria-label="submenu"
                  placeholder="Location (optional)"
                  value={searchFormHandle?.location?.regionName || ""}
                  onChange={(event) =>
                    setsearchFormHandle((prevData: SearchFormHandle) => ({
                      ...prevData,
                      location: event.target.value,
                    }))
                  }
                  readOnly
                  onKeyDown={(e) => {
                    if (!searchFormHandle?.isLocationClicked) return;

                    const listItems = locationlist || [];
                    const currentIndex = listItems.findIndex(
                      (item: any) =>
                        item?.regionUrl ===
                        searchFormHandle?.location?.regionUrl,
                    );
                    switch (e.key) {
                      case "ArrowDown":
                        e.preventDefault();
                        const nextIndex =
                          currentIndex < listItems.length - 1
                            ? currentIndex + 1
                            : 0;
                        setsearchFormHandle((prevData: any) => ({
                          ...prevData,
                          location: listItems[nextIndex],
                        }));
                        // Scroll the selected item into view
                        const nextElement = document.querySelector(
                          `li[data-index="${nextIndex}"]`,
                        );
                        nextElement?.scrollIntoView({
                          block: "nearest",
                          behavior: "smooth",
                        });

                        break;

                      case "ArrowUp":
                        e.preventDefault();
                        const prevIndex =
                          currentIndex > 0
                            ? currentIndex - 1
                            : listItems.length - 1;
                        setsearchFormHandle((prevData: any) => ({
                          ...prevData,
                          location: listItems[prevIndex],
                        }));
                        // Scroll the selected item into view
                        const prevElement = document.querySelector(
                          `li[data-index="${prevIndex}"]`,
                        );
                        prevElement?.scrollIntoView({
                          block: "nearest",
                          behavior: "smooth",
                        });

                        break;

                      case "Enter":
                        e.preventDefault();

                        if (searchFormHandle.location) {
                          courseActions("Location");
                          setsearchFormHandle((prevData: any) => ({
                            ...prevData,
                            isLocationClicked: false,
                          }));
                        }
                        break;
                    }
                  }}
                />
                {searchFormHandle?.isLocationClicked && (
                  <div className="bg-white z-[1] shadow-custom-3 rounded-[4px] absolute left-0 top-[54px] w-full max-h-[310px] overflow-y-auto custom-scrollbar-2">
                    <ul>
                      {locationlist?.map((item: any, index: any) => (
                        <li
                          onClick={() => {
                            setsearchFormHandle(
                              (prevData: SearchFormHandle) => ({
                                ...prevData,
                                location: item,
                              }),
                            );
                            courseActions("Location");
                          }}
                          key={index}
                          data-index={index}
                          className={`block small px-[16px] py-[12px] hover:bg-blue-50 hover:underline cursor-pointer ${
                            item.regionUrl ===
                            searchFormHandle?.location?.regionUrl
                              ? "bg-blue-50 underline"
                              : ""
                          }`}
                        >
                          {item.regionName}
                        </li>
                      ))}
                    </ul>
                  </div>
                )}
              </div>
            )}
            <div
              className={`${showlocation && !isScholarshipSearch ? "pt-0" : "pt-[24px] md:pt-[0]"} `}
            >
              <button
                type="submit"
                data-text-id="search_submit_button"
                className="btn btn-primary flex items-center justify-center gap-[6px] px-[24px] py-[10px] w-full md:w-[114px]"
              >
                <Image
                  src="/static/assets/icons/search_icon.svg"
                  width="18"
                  height="18"
                  alt="Search icon"
                />
                Search
              </button>
            </div>
          </Form>
        </div>
        {subjecterror && (
          <p className="small text-negative-default">
            {isScholarshipSearch
              ? " Please select a subject or university"
              : " Please enter subject"}
          </p>
        )}
      </div>
    </>
  );
};

export default CourseTab;
